<template>
  <div class="flex flex-column justify-center align-items-center gap-2">
    <img class="w-64" alt="" src="/svg/moods/mood-1.svg" />
    <h1 class="text-center">Oh non ! La mise en place du prélèvement n'a pas fonctionnée.<br>Merci de réessayer.</h1>
    <a class="text-2xl text-blue" href="/contact">Besoin d'aide ?</a>
  </div>
</template>

<script>
export default { }
</script>